// extracted by mini-css-extract-plugin
export default {"itemWrap":"style_itemWrap__GcMKZ","left":"style_left__06yrl","label":"style_label__twZGc","total":"style_total__qgCd0","amount":"style_amount__VU2ZV","active":"style_active__Sh0Rx"};